import { render, staticRenderFns } from "./ProductShopIndex.vue?vue&type=template&id=445da0eb&scoped=true"
import script from "./ProductShopIndex.vue?vue&type=script&lang=js"
export * from "./ProductShopIndex.vue?vue&type=script&lang=js"
import style0 from "./ProductShopIndex.vue?vue&type=style&index=0&id=445da0eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445da0eb",
  null
  
)

export default component.exports